import { css } from '@emotion/css'
import { spacing, fontSize, zIndex } from '../../styles'
import { colors } from '../../themes'

const styles = {
  wrapper: css({
    position: 'fixed',
    left: 0,
    right: 0,
    color: colors.mandy,
    backgroundColor: colors.linen,
    zIndex: zIndex.level7,
    overflow: 'hidden',
    transition: 'max-height 0.3s',
  }),

  container: css({
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: spacing.default,
    fontSize: fontSize.small,
    lineHeight: 1.2,
    fontStyle: 'italic',
  }),

  icon: css({
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
}

export default styles

export const wrapperTop = offsetTop =>
  css({
    top: offsetTop,
  })

export const wrapperTransition = status => {
  switch (status) {
    case 'entering':
      return css({
        maxHeight: 0,
      })

    case 'entered':
      return css({
        maxHeight: '30vh', // Set it to something big to generate the transition correctly
      })

    case 'exiting':
    case 'exited':
      return css({
        maxHeight: 0,
      })

    default:
      return css()
  }
}
